export const messages = {

  /**
   * Metadata about this language/locale
   */
  meta: {
    name: 'Español',
  },

  titles: {
    language: 'Idioma',
  },

}
